import { render, staticRenderFns } from "./Jah.vue?vue&type=template&id=19d77391&scoped=true&"
import script from "./Jah.vue?vue&type=script&lang=ts&"
export * from "./Jah.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d77391",
  null
  
)

export default component.exports